export enum RiderTagEnum {
    All = 0,
    Regular = 1,
    CampaignDriver = 2,
    Xpress50 = 3,
    AssignedToBoracayCampaign = 4,
    Xpress50Rider4W = 5
}
